import { render, staticRenderFns } from "./Segmentation.vue?vue&type=template&id=e5da9556&scoped=true"
import script from "./Segmentation.vue?vue&type=script&lang=js"
export * from "./Segmentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5da9556",
  null
  
)

export default component.exports